import { UPDATE_USER_SETTINGS_KEY } from 'src/redux/constants';
import type { IViewDataInitialState } from 'src/redux/viewData/types';

export const updateUserSettingsSuccess = (
  state: IViewDataInitialState,
  action: { payload: Record<string, unknown> },
): IViewDataInitialState => {
  const currentAppConfig = state.GET_APP_CONFIGURATION?.data;
  if (currentAppConfig) {
    const updatedAppConfig = {
      ...currentAppConfig,
      userInfo: {
        ...currentAppConfig.userInfo,
        user_settings: {
          ...currentAppConfig.userInfo.user_settings,
          ...action.payload,
        },
      },
    };

    return {
      ...state,
      GET_APP_CONFIGURATION: {
        ...state.GET_APP_CONFIGURATION,
        data: updatedAppConfig,
      },
      [UPDATE_USER_SETTINGS_KEY]: {
        isFetching: false,
        error: null,
      },
    };
  }
  return state;
};

export const updateUserSettingsFailed = (
  state: IViewDataInitialState,
  action: { payload: unknown },
): IViewDataInitialState => ({
  ...state,
  [UPDATE_USER_SETTINGS_KEY]: {
    isFetching: false,
    error: action.payload,
  },
});
